import Crop from '@dehaat/kisan-app-bl/models/CropV2';
import Image from 'next/image';
import useTranslation from 'next-translate/useTranslation';
import { Dispatch, SetStateAction, useEffect, useRef } from 'react';
import Paragraph, { VARIANT } from '@/components/Paragraph';
import SubHeading from '@/components/SubHeading';
import { SHOW_SOWING_DATE } from '@/constants/common';
import useTriggerEvents from '@/hooks/useTriggerEvents';
import CustomEventTypes from '@/utils/analytics/customEventTypes';
interface Props {
  crop: Crop;
  diseaseImages: Blob[];
  question: string;
  onSubmit: VoidFunction;
  setCurrentCrumbIndex: Dispatch<SetStateAction<number>>;
  setQuestion: Dispatch<SetStateAction<string>>;
}
const PostQuestion = ({
  crop: {
    app_display_name = '',
    image_url
  },
  diseaseImages,
  question,
  onSubmit,
  setCurrentCrumbIndex,
  setQuestion
}: Props) => {
  const diseaseImageUrls = useRef<string[]>(diseaseImages.map(URL.createObjectURL));
  const questionInputRef = useRef<HTMLTextAreaElement>(null);
  const {
    t
  } = useTranslation('askQuestion');
  const {
    trackCustomEvent
  } = useTriggerEvents();
  useEffect(() => {
    questionInputRef.current?.focus();
    questionInputRef.current?.scrollIntoView();
  }, []);
  return <>
      <div className="bg-white grow p-4">
        <SubHeading className="mt-2" data-sentry-element="SubHeading" data-sentry-source-file="PostQuestion.tsx">{t('clicked_photos')}</SubHeading>
        {diseaseImageUrls.current.map(url => <div className="h-20 mt-2 overflow-hidden relative rounded-lg w-20" key={url}>
            <Image alt="Disease image" fill src={url} />
          </div>)}
        <SubHeading className="mt-10" data-sentry-element="SubHeading" data-sentry-source-file="PostQuestion.tsx">{t('diseased_crop')}</SubHeading>
        <div className="text-center w-20">
          <div className="border border-neutral-20 h-20 mt-2 overflow-hidden relative rounded-full w-20">
            <Image alt={app_display_name} className="object-cover" fill src={image_url} data-sentry-element="Image" data-sentry-source-file="PostQuestion.tsx" />
          </div>
          {app_display_name ?? <Paragraph className="mt-1 text-neutral-80" variant={VARIANT.MEDIUM}>
            {app_display_name}
          </Paragraph>}
        </div>
        <SubHeading className="mt-10" data-sentry-element="SubHeading" data-sentry-source-file="PostQuestion.tsx">{t('ask_your_question')}</SubHeading>
        <textarea className="border h-36 mt-2 p-4 rounded-lg shadow-md w-full" onChange={e => setQuestion(e.target.value)} placeholder={t('write_symptom')} ref={questionInputRef} value={question} />
      </div>
      <div className="bg-white bottom-0 fixed m-auto max-w-7xl p-4 w-full">
        <button className={`p-4 rounded-lg text-white w-full ${question ? 'bg-primary-100' : 'bg-neutral-30'}`} disabled={!question} onClick={() => {
        const eventParams = {
          Question: question
        };
        trackCustomEvent(CustomEventTypes.ASK_HELP_QUESTION_SAVED, JSON.stringify(eventParams));
        (SHOW_SOWING_DATE ? () => setCurrentCrumbIndex(3) : onSubmit)();
      }}>
          {SHOW_SOWING_DATE ? t('proceed_details') : t('proceed')}
        </button>
      </div>
    </>;
};
export default PostQuestion;